// src/_helpers/formatters.ts
export const formatStorage = (bytes: number, t: (key: string) => string) => {
    if (bytes === 0) return `0 ${t('storage.byte')}`;

    const k = 1024;
    const sizes = [
        t('storage.byte'),
        t('storage.kilobyte'),
        t('storage.megabyte'),
        t('storage.gigabyte'),
        t('storage.terabyte'),
        t('storage.petabyte'),
        t('storage.exabyte'),
        t('storage.zettabyte'),
        t('storage.yottabyte'),
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedNumber = parseFloat((bytes / Math.pow(k, i)).toFixed(2));

    return `${formattedNumber} ${sizes[i]}`;
}